module.exports = __webpack_public_path__ + "assets/fonts/iconfont.cd90b837.ttf";